import React from "react";
import PropTypes from "prop-types";

export default function LoginUser(props) {
  return (
    <svg
      className={props.className}
      width={props.width}
      height={props.height}
      viewBox={`0 0 ${props.width} ${props.height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M78.5454 0C81.1776 0 83.6934 0.512323 86 1.44331C86 10.8398 86 26.5388 86 39.1622C83.6934 40.0931 81.1776 40.6055 78.5454 40.6055C67.4472 40.6055 58.4182 31.4977 58.4182 20.3027C58.4182 9.10781 67.4472 0 78.5454 0Z"
        fill={props.fill}
      />
      <path
        d="M53.5032 53.8692C59.0136 48.2253 66.3186 45.1172 74.0727 45.1172H83.0181C84.0205 45.1172 84.8818 45.1172 86 45.1172C85.9995 57.0347 86.0002 68.7767 86 77H47.2364C46.0013 77 45 75.99 45 74.7441C45 66.8987 48.0198 59.4854 53.5032 53.8692Z"
        fill={props.fill}
      />
      <path
        d="M0 35.6806L3.8147e-06 38.3235L33.7609 38.3235L22.5728 49.1312L24.5073 51L39 37L24.5073 23L22.5728 24.8688L33.7652 35.6806L0 35.6806Z"
        fill={props.fill}
      />
    </svg>
  );
}

LoginUser.propTypes = {
  fill: PropTypes.string,
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};
LoginUser.defaultProps = {
  className: "",
  fill: "#E9F1FE",
  width: 86,
  height: 77
};
